import React from 'react'

import classNames from 'classnames'

import { IconWrapper } from '../components'

export const IconSliceMapPinFill = ({
  size,
  color,
  className,
  ...props
}: React.ComponentPropsWithoutRef<'svg'> & {
  size?: string | number
}) => (
  <IconWrapper {...props} className={classNames(className, "icon-centivo", "icon-centivo--slice-map-pin-fill")} iconColor={color} size={size} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <mask id="mask0_3894_202" style={{ maskType: "alpha", }} maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
  <rect width="24" height="24" fill="#D9D9D9"/>
  </mask>
  <g mask="url(#mask0_3894_202)">
  <path d="M12 11.5C12.4218 11.5 12.7773 11.3555 13.0663 11.0664C13.3554 10.7773 13.5 10.4218 13.5 10C13.5 9.5782 13.3554 9.22275 13.0663 8.93365C12.7773 8.64455 12.4218 8.5 12 8.5C11.5782 8.5 11.2228 8.64455 10.9337 8.93365C10.6446 9.22275 10.5 9.5782 10.5 10C10.5 10.4218 10.6446 10.7773 10.9337 11.0664C11.2228 11.3555 11.5782 11.5 12 11.5ZM12 21.6154C9.47052 19.3705 7.58814 17.2881 6.35288 15.3683C5.11763 13.4484 4.5 11.7257 4.5 10.2C4.5 7.85385 5.25609 5.98397 6.76827 4.59037C8.28044 3.19679 10.0244 2.5 12 2.5C13.9756 2.5 15.7196 3.19679 17.2317 4.59037C18.7439 5.98397 19.5 7.85385 19.5 10.2C19.5 11.7257 18.8824 13.4484 17.6471 15.3683C16.4119 17.2881 14.5295 19.3705 12 21.6154Z" fill="#403CAB"/>
  </g>
  </IconWrapper>
)
